import { render, staticRenderFns } from "./DropdownUser.vue?vue&type=template&id=d6a46b4e&scoped=true&"
import script from "./DropdownUser.vue?vue&type=script&lang=ts&"
export * from "./DropdownUser.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownUser.vue?vue&type=style&index=0&id=d6a46b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a46b4e",
  null
  
)

export default component.exports